const localizedLandingCopy = {
  fr: {
    navLabel: 'Navigation principale',
    navItems: [
      { label: 'Produit', href: '#product' },
      { label: 'Fonctionnement', href: '#how-it-works' },
      { label: 'Sécurité', href: '#security' },
    ],
    docs: 'Documentation',
    menuOpen: 'Ouvrir le menu de navigation',
    menuClose: 'Fermer le menu de navigation',
    themeLight: 'Activer le thème clair',
    themeDark: 'Activer le thème sombre',
    eyebrow: 'Des paiements adaptés à votre activité',
    title: 'Le moyen le plus simple d’être payé en ligne.',
    titleAccent: 'en ligne.',
    intro: 'Liens de paiement, factures et API dans un espace de travail unique. Hola Pay vous aide à encaisser, contrôler et rapprocher vos paiements sans étapes inutiles.',
    heroImageAlt: 'Illustration Hola Pay avec sa mascotte, un lien de paiement et une carte.',
    heroServicesLabel: 'TOUT POUR GÉRER VOS ENCAISSEMENTS',
    heroServices: ['Liens de paiement', 'Factures', 'API', 'Activité'],
    start: 'Créer votre compte',
    login: 'Se connecter',
    hasAccount: 'Vous avez déjà un compte ?',
    noteOne: 'Activation guidée',
    noteTwo: 'Encaissements en EUR',
    noteThree: 'Assistance humaine',
    workspace: 'Un espace pour chaque paiement',
    workspaceIntro: 'De la première demande au paiement confirmé, chaque outil reste connecté et facile à consulter.',
    workspaceOverline: '01 / Un parcours connecté',
    workspaceImageAlt: 'Hola Pay : trois façons pratiques d’encaisser et un point de départ clair pour chaque paiement.',
    productStoryOverline: 'CHAT HOLA PAY / DANS LE PRODUIT',
    productStoryTitle: 'Je vous accompagne dès le premier clic.',
    productStoryBody: 'Liens, factures et API fonctionnent ensemble dans un espace clair, sans étapes cachées.',
    productStoryAlt: 'Le chat Hola Pay avec des liens de paiement, des factures automatiques et des API intégrées.',
    activitySectionHeadline: 'Tous vos paiements, clairement visibles.',
    securitySectionHeadline: 'Une protection claire pour chaque paiement.',
    capabilities: 'Trois façons simples d’encaisser',
    activity: 'Activité récente',
    activityIntro: 'Suivez les liens, les factures et les paiements en temps réel depuis votre espace de travail.',
    details: 'Voir le fonctionnement',
    securityTitle: 'Plus de clarté, moins de tâches manuelles.',
    securityBody: 'Les autorisations, les événements et le statut des paiements restent visibles à chaque étape.',
    finalTitle: 'Prêt pour votre prochain paiement ?',
    finalBody: 'Commencez par un lien et ajoutez le reste selon vos besoins.',
    createLink: 'Créer un lien',
    viewActivity: 'Voir l’activité',
    footerLine: 'Des paiements simples pour les entreprises en croissance.',
    footerLanguages: 'Italien · Anglais · Français · Espagnol · Arabe',
    workbenchOverline: '03 / Au quotidien',
    workbenchTitleFirst: 'Créez votre parcours.',
    workbenchTitleSecond: 'Voyez-le en action.',
    workbenchImageAlt: 'Tableau de bord Hola Pay avec les paiements, les liens actifs et les factures.',
    checkoutLabel: '01 / ENCAISSEMENT',
    checkoutTitleFirst: 'Créez une fois.',
    checkoutTitleSecond: 'Partagez partout.',
    checkoutBody: 'Un lien clair, un QR code prêt à l’emploi et un paiement suivi à chaque étape. Envoyez-le par message, e-mail ou au comptoir.',
    checkoutImageAlt: 'Parcours Hola Pay pour créer un paiement sécurisé.',
    activityOverline: 'Paiements / En temps réel',
    activityImageAlt: 'Aperçu Hola Pay des paiements, liens, factures et mises à jour du portefeuille.',
    activityBoardOverline: '04 / Visibilité',
    activityBoardDate: 'Mardi 17 septembre',
    activityBoardLive: 'En direct',
    activityBoardAwaitingPayment: 'En attente de paiement',
    activityBoardTomorrow: 'Demain',
    activityBoardUpdates: 'Mise à jour automatique',
    activityBoardOpenWorkspace: 'Ouvrir l’espace de travail',
    securityOverline: 'Hola Pay / Protection',
    securityImageAlt: 'Hola Pay : plus de clarté et moins de tâches manuelles.',
    close: 'Fermer',
    sectionIds: { product: 'product', howItWorks: 'how-it-works', activity: 'activity', security: 'security' },
  },
  ar: {
    navLabel: 'التنقل الرئيسي',
    navItems: [
      { label: 'المنتج', href: '#product' },
      { label: 'طريقة العمل', href: '#how-it-works' },
      { label: 'الأمان', href: '#security' },
    ],
    docs: 'التوثيق',
    menuOpen: 'فتح قائمة التنقل',
    menuClose: 'إغلاق قائمة التنقل',
    themeLight: 'تفعيل المظهر الفاتح',
    themeDark: 'تفعيل المظهر الداكن',
    eyebrow: 'مدفوعات تناسب عملك',
    title: 'أسهل طريقة لاستلام المدفوعات عبر الإنترنت.',
    titleAccent: 'الإنترنت.',
    intro: 'روابط الدفع والفواتير وواجهات API في مساحة عمل واحدة. تساعدك Hola Pay على تحصيل المدفوعات ومراجعتها وتسويتها بخطوات أقل.',
    heroImageAlt: 'رسم توضيحي لـ Hola Pay مع التميمة ورابط دفع وبطاقة.',
    heroServicesLabel: 'كل ما تحتاجه لإدارة مدفوعاتك',
    heroServices: ['روابط الدفع', 'الفواتير', 'واجهات API', 'النشاط'],
    start: 'أنشئ حسابك',
    login: 'تسجيل الدخول',
    hasAccount: 'لديك حساب بالفعل؟',
    noteOne: 'تفعيل بإرشاد مباشر',
    noteTwo: 'تحصيل باليورو',
    noteThree: 'دعم بشري',
    workspace: 'مساحة واحدة لكل دفعة',
    workspaceIntro: 'من أول طلب حتى تأكيد الدفع، تبقى كل الأدوات مترابطة وسهلة المتابعة.',
    workspaceOverline: '01 / مسار مترابط',
    workspaceImageAlt: 'Hola Pay: ثلاث طرق عملية للتحصيل ونقطة بداية واضحة لكل دفعة.',
    productStoryOverline: 'قطة HOLA PAY / داخل المنتج',
    productStoryTitle: 'أنا معك من أول نقرة.',
    productStoryBody: 'تعمل الروابط والفواتير وواجهات API معاً في مساحة واضحة، بلا خطوات مخفية.',
    productStoryAlt: 'قطة Hola Pay مع روابط الدفع والفواتير التلقائية وواجهات API المتكاملة.',
    activitySectionHeadline: 'كل دفعة واضحة أمامك.',
    securitySectionHeadline: 'حماية واضحة لكل دفعة.',
    capabilities: 'ثلاث طرق عملية للتحصيل',
    activity: 'النشاط الأخير',
    activityIntro: 'تابع الروابط والفواتير والمدفوعات لحظة بلحظة من مساحة عملك.',
    details: 'اكتشف طريقة العمل',
    securityTitle: 'وضوح أكثر وعمل يدوي أقل.',
    securityBody: 'تظل الصلاحيات والأحداث وحالة الدفع ظاهرة في كل خطوة.',
    finalTitle: 'هل أنت مستعد للدفعة التالية؟',
    finalBody: 'ابدأ برابط دفع وأضف الأدوات الأخرى عند الحاجة.',
    createLink: 'إنشاء رابط',
    viewActivity: 'عرض النشاط',
    footerLine: 'مدفوعات بسيطة للأنشطة التي تنمو.',
    footerLanguages: 'الإيطالية · الإنجليزية · الفرنسية · الإسبانية · العربية',
    workbenchOverline: '03 / في العمل اليومي',
    workbenchTitleFirst: 'أنشئ مسار الدفع.',
    workbenchTitleSecond: 'وشاهده يعمل.',
    workbenchImageAlt: 'لوحة Hola Pay تعرض المدفوعات والروابط النشطة والفواتير.',
    checkoutLabel: '01 / التحصيل',
    checkoutTitleFirst: 'أنشئه مرة واحدة.',
    checkoutTitleSecond: 'وشاركه في كل مكان.',
    checkoutBody: 'رابط واضح ورمز QR جاهز ودفعة يمكنك متابعتها. أرسله عبر الرسائل أو البريد الإلكتروني أو اعرضه عند الدفع.',
    checkoutImageAlt: 'خطوات Hola Pay لإنشاء دفعة آمنة.',
    activityOverline: 'المدفوعات / مباشرة',
    activityImageAlt: 'معاينة Hola Pay للنشاط الأخير والمدفوعات والروابط والفواتير وتحديثات المحفظة.',
    activityBoardOverline: '04 / متابعة المدفوعات',
    activityBoardDate: 'الثلاثاء، 17 سبتمبر',
    activityBoardLive: 'مباشر',
    activityBoardAwaitingPayment: 'بانتظار الدفع',
    activityBoardTomorrow: 'غداً',
    activityBoardUpdates: 'تحديث تلقائي',
    activityBoardOpenWorkspace: 'فتح مساحة العمل',
    securityOverline: 'Hola Pay / الأمان',
    securityImageAlt: 'Hola Pay: وضوح أكثر وعمل يدوي أقل.',
    close: 'إغلاق',
    sectionIds: { product: 'product', howItWorks: 'how-it-works', activity: 'activity', security: 'security' },
  },
  es: {
    navLabel: 'Navegación principal',
    navItems: [
      { label: 'Producto', href: '#product' },
      { label: 'Cómo funciona', href: '#how-it-works' },
      { label: 'Seguridad', href: '#security' },
    ],
    docs: 'Documentación',
    menuOpen: 'Abrir el menú de navegación',
    menuClose: 'Cerrar el menú de navegación',
    themeLight: 'Activar el tema claro',
    themeDark: 'Activar el tema oscuro',
    eyebrow: 'Pagos pensados para tu trabajo',
    title: 'La forma más sencilla de cobrar en línea.',
    titleAccent: 'en línea.',
    intro: 'Enlaces de pago, facturas y API en un único espacio de trabajo. Hola Pay te ayuda a cobrar, revisar y conciliar sin pasos innecesarios.',
    heroImageAlt: 'Ilustración de Hola Pay con su mascota, un enlace de pago y una tarjeta.',
    heroServicesLabel: 'TODO PARA GESTIONAR TUS COBROS',
    heroServices: ['Enlaces de pago', 'Facturas', 'API', 'Actividad'],
    start: 'Crear tu cuenta',
    login: 'Iniciar sesión',
    hasAccount: '¿Ya tienes una cuenta?',
    noteOne: 'Activación guiada',
    noteTwo: 'Cobros en EUR',
    noteThree: 'Atención humana',
    workspace: 'Un espacio para cada pago',
    workspaceIntro: 'Desde la primera solicitud hasta el pago completado, cada herramienta permanece conectada y clara.',
    workspaceOverline: '01 / Un flujo conectado',
    workspaceImageAlt: 'Hola Pay: tres formas prácticas de cobrar y un punto de partida claro para cada pago.',
    productStoryOverline: 'GATO HOLA PAY / EN EL PRODUCTO',
    productStoryTitle: 'Te acompaño desde el primer clic.',
    productStoryBody: 'Los enlaces, las facturas y las API trabajan juntos en un espacio claro, sin pasos ocultos.',
    productStoryAlt: 'El gato de Hola Pay con enlaces de pago, facturas automáticas e API integradas.',
    activitySectionHeadline: 'Cada pago, siempre a la vista.',
    securitySectionHeadline: 'Protección clara para cada pago.',
    capabilities: 'Tres formas prácticas de cobrar',
    activity: 'Actividad reciente',
    activityIntro: 'Sigue los enlaces, las facturas y los pagos en tiempo real desde tu espacio de trabajo.',
    details: 'Descubre cómo funciona',
    securityTitle: 'Más claridad, menos trabajo manual.',
    securityBody: 'Los permisos, los eventos y el estado de los pagos están visibles en cada paso.',
    finalTitle: '¿Listo para el próximo pago?',
    finalBody: 'Empieza con un enlace y añade lo demás cuando lo necesites.',
    createLink: 'Crear un enlace',
    viewActivity: 'Ver actividad',
    footerLine: 'Pagos sencillos para negocios en crecimiento.',
    footerLanguages: 'Italiano · Inglés · Francés · Español · Árabe',
    workbenchOverline: '03 / En el trabajo diario',
    workbenchTitleFirst: 'Crea el flujo.',
    workbenchTitleSecond: 'Mira cómo funciona.',
    workbenchImageAlt: 'Panel de Hola Pay con pagos, enlaces activos y facturas.',
    checkoutLabel: '01 / COBROS',
    checkoutTitleFirst: 'Créalo una vez.',
    checkoutTitleSecond: 'Compártelo donde quieras.',
    checkoutBody: 'Un enlace claro, un QR listo y un pago que puedes seguir. Funciona por mensaje, correo electrónico o en el mostrador.',
    checkoutImageAlt: 'Flujo de Hola Pay para crear un pago seguro.',
    activityOverline: 'Pagos / En tiempo real',
    activityImageAlt: 'Vista previa de Hola Pay con pagos, enlaces, facturas y actualizaciones de la cartera.',
    activityBoardOverline: '04 / Visibilidad',
    activityBoardDate: 'Martes, 17 de septiembre',
    activityBoardLive: 'En directo',
    activityBoardAwaitingPayment: 'Pendiente de pago',
    activityBoardTomorrow: 'Mañana',
    activityBoardUpdates: 'Actualización automática',
    activityBoardOpenWorkspace: 'Abrir el espacio de trabajo',
    securityOverline: 'Hola Pay / Protección',
    securityImageAlt: 'Hola Pay: más claridad y menos trabajo manual.',
    close: 'Cerrar',
    sectionIds: { product: 'product', howItWorks: 'how-it-works', activity: 'activity', security: 'security' },
  },
  de: {
    navLabel: 'Hauptnavigation',
    navItems: [
      { label: 'Produkt', href: '#product' },
      { label: 'So funktioniert es', href: '#how-it-works' },
      { label: 'Sicherheit', href: '#security' },
    ],
    docs: 'Dokumentation',
    menuOpen: 'Navigationsmenü öffnen',
    menuClose: 'Navigationsmenü schließen',
    themeLight: 'Helles Design aktivieren',
    themeDark: 'Dunkles Design aktivieren',
    eyebrow: 'Zahlungen, die zu deiner Arbeit passen',
    title: 'So einfach erhältst du Zahlungen online.',
    titleAccent: 'Zahlungen online.',
    intro: 'Zahlungslinks, Rechnungen und APIs an einem zentralen Arbeitsplatz. Hola Pay hilft dir, Zahlungen ohne unnötige Schritte einzuziehen, zu prüfen und abzugleichen.',
    heroImageAlt: 'Hola-Pay-Illustration mit Maskottchen, Zahlungslink und Karte.',
    heroServicesLabel: 'ALLES FÜR DEINE ZAHLUNGSEINGÄNGE',
    heroServices: ['Zahlungslinks', 'Rechnungen', 'APIs', 'Aktivität'],
    start: 'Konto erstellen',
    login: 'Anmelden',
    hasAccount: 'Du hast bereits ein Konto?',
    noteOne: 'Geführte Aktivierung',
    noteTwo: 'Zahlungseingänge in EUR',
    noteThree: 'Persönlicher Support',
    workspace: 'Ein Arbeitsplatz für jede Zahlung',
    workspaceIntro: 'Von der ersten Anfrage bis zur abgeschlossenen Zahlung bleiben alle Tools verbunden und übersichtlich.',
    workspaceOverline: '01 / Ein verbundener Ablauf',
    workspaceImageAlt: 'Hola Pay: drei praktische Wege zum Kassieren und ein klarer Startpunkt für jede Zahlung.',
    productStoryOverline: 'HOLA-PAY-KATZE / IM PRODUKT',
    productStoryTitle: 'Ich begleite dich ab dem ersten Klick.',
    productStoryBody: 'Links, Rechnungen und APIs arbeiten in einer übersichtlichen Umgebung zusammen – ohne versteckte Schritte.',
    productStoryAlt: 'Hola Pay Cat mit Zahlungslinks, automatischen Rechnungen und integrierten APIs.',
    activitySectionHeadline: 'Jede Zahlung klar im Blick.',
    securitySectionHeadline: 'Klare Sicherheit für jede Zahlung.',
    capabilities: 'Drei praktische Wege zum Kassieren',
    activity: 'Letzte Aktivitäten',
    activityIntro: 'Verfolge Links, Rechnungen und Zahlungen in Echtzeit an einem Ort.',
    details: 'So funktioniert es',
    securityTitle: 'Mehr Überblick, weniger Handarbeit.',
    securityBody: 'Berechtigungen, Ereignisse und Zahlungsstatus bleiben jederzeit sichtbar.',
    finalTitle: 'Bereit für die nächste Zahlung?',
    finalBody: 'Starte mit einem Link und ergänze weitere Tools bei Bedarf.',
    createLink: 'Link erstellen',
    viewActivity: 'Aktivität ansehen',
    footerLine: 'Einfache Zahlungen für wachsende Unternehmen.',
    footerLanguages: 'Italienisch · Englisch · Französisch · Spanisch · Arabisch',
    workbenchOverline: '03 / Im Arbeitsalltag',
    workbenchTitleFirst: 'Erstelle den Ablauf.',
    workbenchTitleSecond: 'Sieh ihn in Aktion.',
    workbenchImageAlt: 'Hola-Pay-Dashboard mit Zahlungen, aktiven Links und Rechnungen.',
    checkoutLabel: '01 / ZAHLUNGSEINGANG',
    checkoutTitleFirst: 'Einmal erstellen.',
    checkoutTitleSecond: 'Überall teilen.',
    checkoutBody: 'Ein klarer Link, ein QR-Code und eine Zahlung, die du verfolgen kannst. Teile sie im Chat, per E-Mail oder direkt vor Ort.',
    checkoutImageAlt: 'Hola-Pay-Ablauf zum Erstellen einer sicheren Zahlung.',
    activityOverline: 'Zahlungen / Live',
    activityImageAlt: 'Hola-Pay-Vorschau mit Aktivitäten, Zahlungen, Links, Rechnungen und Wallet-Updates.',
    activityBoardOverline: '04 / Überblick',
    activityBoardDate: 'Dienstag, 17. September',
    activityBoardLive: 'Live',
    activityBoardAwaitingPayment: 'Zahlung ausstehend',
    activityBoardTomorrow: 'Morgen',
    activityBoardUpdates: 'Automatische Aktualisierung',
    activityBoardOpenWorkspace: 'Arbeitsbereich öffnen',
    securityOverline: 'Hola Pay / Sicherheit',
    securityImageAlt: 'Hola Pay: mehr Überblick und weniger Handarbeit.',
    close: 'Schließen',
    sectionIds: { product: 'product', howItWorks: 'how-it-works', activity: 'activity', security: 'security' },
  },
  ru: {
    navLabel: 'Основная навигация',
    navItems: [
      { label: 'Продукт', href: '#product' },
      { label: 'Как это работает', href: '#how-it-works' },
      { label: 'Безопасность', href: '#security' },
    ],
    docs: 'Документация',
    menuOpen: 'Открыть меню навигации',
    menuClose: 'Закрыть меню навигации',
    themeLight: 'Включить светлую тему',
    themeDark: 'Включить тёмную тему',
    eyebrow: 'Платежи для вашей работы',
    title: 'Простой способ получать оплату онлайн.',
    titleAccent: 'онлайн.',
    intro: 'Платёжные ссылки, счета и API в одном рабочем пространстве. Hola Pay помогает принимать, проверять и сверять платежи без лишних шагов.',
    heroImageAlt: 'Иллюстрация Hola Pay с маскотом, платёжной ссылкой и картой.',
    heroServicesLabel: 'ВСЁ ДЛЯ УПРАВЛЕНИЯ ПЛАТЕЖАМИ',
    heroServices: ['Платёжные ссылки', 'Счета', 'API', 'Операции'],
    start: 'Создать аккаунт',
    login: 'Войти',
    hasAccount: 'Уже есть аккаунт?',
    noteOne: 'Помощь с запуском',
    noteTwo: 'Платежи в EUR',
    noteThree: 'Поддержка специалистов',
    workspace: 'Одно пространство для каждого платежа',
    workspaceIntro: 'От первого запроса до завершённого платежа все инструменты связаны и доступны для просмотра.',
    workspaceOverline: '01 / Связанный процесс',
    workspaceImageAlt: 'Hola Pay: три удобных способа принимать платежи и понятный старт для каждого платежа.',
    productStoryOverline: 'КОТ HOLA PAY / В ПРОДУКТЕ',
    productStoryTitle: 'Я рядом с первого клика.',
    productStoryBody: 'Ссылки, счета и API работают вместе в понятном пространстве без скрытых шагов.',
    productStoryAlt: 'Кот Hola Pay, платёжные ссылки, автоматические счета и интеграция API.',
    activitySectionHeadline: 'Каждый платёж всегда на виду.',
    securitySectionHeadline: 'Понятная защита каждого платежа.',
    capabilities: 'Три удобных способа принимать платежи',
    activity: 'Последние операции',
    activityIntro: 'Следите за ссылками, счетами и платежами в реальном времени.',
    details: 'Узнать, как это работает',
    securityTitle: 'Больше ясности, меньше ручной работы.',
    securityBody: 'Права доступа, события и статусы платежей видны на каждом этапе.',
    finalTitle: 'Готовы к следующему платежу?',
    finalBody: 'Начните со ссылки и добавляйте инструменты по мере необходимости.',
    createLink: 'Создать ссылку',
    viewActivity: 'Посмотреть операции',
    footerLine: 'Простые платежи для растущего бизнеса.',
    footerLanguages: 'Итальянский · Английский · Французский · Испанский · Арабский',
    workbenchOverline: '03 / В повседневной работе',
    workbenchTitleFirst: 'Настройте процесс.',
    workbenchTitleSecond: 'Посмотрите, как он работает.',
    workbenchImageAlt: 'Панель Hola Pay с платежами, активными ссылками и счетами.',
    checkoutLabel: '01 / ПРИЁМ ПЛАТЕЖЕЙ',
    checkoutTitleFirst: 'Создайте один раз.',
    checkoutTitleSecond: 'Поделитесь где угодно.',
    checkoutBody: 'Понятная ссылка, готовый QR-код и платёж, за которым можно следить. Отправьте ссылку в сообщении, по почте или покажите на кассе.',
    checkoutImageAlt: 'Процесс Hola Pay для создания безопасного платежа.',
    activityOverline: 'Платежи / В реальном времени',
    activityImageAlt: 'Обзор Hola Pay: операции, платежи, ссылки, счета и обновления кошелька.',
    activityBoardOverline: '04 / Обзор',
    activityBoardDate: 'Вторник, 17 сентября',
    activityBoardLive: 'В эфире',
    activityBoardAwaitingPayment: 'Ожидает оплаты',
    activityBoardTomorrow: 'Завтра',
    activityBoardUpdates: 'Обновляется автоматически',
    activityBoardOpenWorkspace: 'Открыть рабочее пространство',
    securityOverline: 'Hola Pay / Защита',
    securityImageAlt: 'Hola Pay: больше ясности, меньше ручной работы.',
    close: 'Закрыть',
    sectionIds: { product: 'product', howItWorks: 'how-it-works', activity: 'activity', security: 'security' },
  },
};

const localizedCapabilities = {
  fr: [
    { key: 'links', label: 'Liens de paiement', title: 'Un lien, une vente, sans friction.', description: 'Créez une page de paiement partageable, ajoutez un montant et envoyez-la là où se trouvent déjà vos clients.', cta: 'Créer un lien', route: '/register', points: ['Montant fixe ou libre', 'QR code prêt à afficher', 'Statut du paiement toujours visible'] },
    { key: 'invoices', label: 'Factures', title: 'Des factures qui accélèrent le paiement.', description: 'Créez une facture claire, reliez-la au paiement et gardez le document, l’échéance et l’encaissement ensemble.', cta: 'Découvrir les factures', route: '/register', points: ['Numérotation cohérente', 'Échéances sous contrôle', 'Envoi avec lien de paiement'] },
    { key: 'api', label: 'API et intégrations', title: 'Reliez votre produit aux paiements.', description: 'Une API claire et des webhooks fiables pour intégrer les paiements à votre produit.', points: ['Clés distinctes par environnement', 'Événements webhook traçables', 'Environnement de test sécurisé'] },
  ],
  ar: [
    { key: 'links', label: 'روابط الدفع', title: 'رابط واحد، عملية بيع سهلة.', description: 'أنشئ صفحة دفع قابلة للمشاركة، وأضف المبلغ، ثم أرسلها إلى المكان الذي يتواجد فيه عملاؤك.', cta: 'إنشاء رابط', route: '/register', points: ['مبلغ ثابت أو يحدده العميل', 'رمز QR جاهز للعرض', 'حالة الدفع ظاهرة دائماً'] },
    { key: 'invoices', label: 'الفواتير', title: 'فواتير تقود إلى الدفع.', description: 'أنشئ فاتورة واضحة واربطها بالدفع، واجمع المستند وتاريخ الاستحقاق والتحصيل في مكان واحد.', cta: 'استكشف الفواتير', route: '/register', points: ['ترقيم منظم', 'متابعة مواعيد الاستحقاق', 'إرسال مع رابط دفع'] },
    { key: 'api', label: 'واجهات API والتكاملات', title: 'اربط منتجك بالمدفوعات.', description: 'واجهة API واضحة وإشعارات webhook موثوقة لدمج المدفوعات في منتجك.', points: ['مفاتيح منفصلة لكل بيئة', 'تتبع أحداث webhook', 'بيئة اختبار آمنة'] },
  ],
  es: [
    { key: 'links', label: 'Enlaces de pago', title: 'Un enlace, una venta y cero fricción.', description: 'Crea una página de pago para compartir, añade un importe y envíala donde ya están tus clientes.', cta: 'Crear un enlace', route: '/register', points: ['Importe fijo o editable', 'QR listo para mostrar', 'Estado del pago siempre visible'] },
    { key: 'invoices', label: 'Facturas', title: 'Facturas que llevan al pago.', description: 'Crea una factura clara, conéctala al pago y mantén juntos el documento, el vencimiento y el cobro.', cta: 'Ver facturas', route: '/register', points: ['Numeración ordenada', 'Vencimientos bajo control', 'Envío con enlace de pago'] },
    { key: 'api', label: 'API e integraciones', title: 'Conecta tu producto con los pagos.', description: 'Una API clara y webhooks fiables para integrar los pagos en tu producto.', points: ['Claves separadas por entorno', 'Eventos webhook trazables', 'Entorno de pruebas seguro'] },
  ],
  de: [
    { key: 'links', label: 'Zahlungslinks', title: 'Ein Link, ein Verkauf, ohne Umwege.', description: 'Erstelle eine teilbare Zahlungsseite, lege einen Betrag fest und sende sie dorthin, wo deine Kunden bereits sind.', cta: 'Link erstellen', route: '/register', points: ['Fester oder frei wählbarer Betrag', 'QR-Code sofort einsatzbereit', 'Zahlungsstatus jederzeit sichtbar'] },
    { key: 'invoices', label: 'Rechnungen', title: 'Rechnungen, die zur Zahlung führen.', description: 'Erstelle eine übersichtliche Rechnung, verknüpfe sie mit der Zahlung und bündele Dokument, Fälligkeit und Eingang.', cta: 'Rechnungen ansehen', route: '/register', points: ['Einheitliche Nummerierung', 'Fälligkeiten im Blick', 'Versand mit Zahlungslink'] },
    { key: 'api', label: 'APIs und Integrationen', title: 'Verbinde dein Produkt mit Zahlungen.', description: 'Eine verständliche API und zuverlässige Webhooks für Zahlungen direkt in deinem Produkt.', points: ['Getrennte Schlüssel je Umgebung', 'Nachvollziehbare Webhook-Ereignisse', 'Sichere Testumgebung'] },
  ],
  ru: [
    { key: 'links', label: 'Платёжные ссылки', title: 'Одна ссылка — одна продажа, без лишних шагов.', description: 'Создайте страницу оплаты, укажите сумму и отправьте её туда, где ваши клиенты уже общаются.', cta: 'Создать ссылку', route: '/register', points: ['Фиксированная сумма или сумма от клиента', 'QR-код готов к показу', 'Статус платежа всегда виден'] },
    { key: 'invoices', label: 'Счета', title: 'Счета, по которым удобно платить.', description: 'Создайте понятный счёт, свяжите его с оплатой и храните документ, срок и поступление вместе.', cta: 'Посмотреть счета', route: '/register', points: ['Удобная нумерация', 'Контроль сроков оплаты', 'Отправка со ссылкой на оплату'] },
    { key: 'api', label: 'API и интеграции', title: 'Свяжите продукт с платежами.', description: 'Понятный API и надёжные webhook-уведомления для интеграции платежей в ваш продукт.', points: ['Отдельные ключи для каждой среды', 'Отслеживаемые события webhook', 'Безопасная тестовая среда'] },
  ],
};

export { localizedLandingCopy, localizedCapabilities };